import { GridComponent } from "@syncfusion/ej2-react-grids";

const makeGridAACompliant = (grid: GridComponent, fixComplete: () => void) => {
  document.querySelectorAll(".e-currentitem")?.forEach(item => {
    item.removeAttribute("aria-selected");
  });

  document.querySelectorAll(".e-input-group input")?.forEach(selector => {
    selector.setAttribute("role", "textbox");
    selector.removeAttribute("aria-expanded");
    selector.removeAttribute("aria-label");
  });

  if (grid) {
    grid!
      .getHeaderContent()
      ?.querySelectorAll(".e-headercell")
      ?.forEach(item => item.removeAttribute("aria-description"));
    grid!
      .getContent()
      ?.querySelectorAll(".e-templatecell")
      .forEach(item => item.removeAttribute("aria-label"));

    const pager = grid!.getPager()!;
    if (pager) {
      pager.removeAttribute("aria-label");
      pager
        .querySelectorAll(".e-link")
        ?.forEach(item => item.removeAttribute("aria-selected"));

      const pagerSelector = pager.querySelector(".e-input-group");
      if (pagerSelector) {
        pagerSelector.removeAttribute("aria-disabled");
        pagerSelector.removeAttribute("aria-expanded");
        pagerSelector.removeAttribute("role");
        pagerSelector.removeAttribute("aria-labelledby");
        pagerSelector.removeAttribute("aria-label");
      }

      pager.querySelectorAll(".e-icons, .e-parentmsgbar")?.forEach(item => {
        item.removeAttribute("aria-label");
        item.removeAttribute("aria-owns");
      });
    }
  }

  fixComplete();
};

const makeDateRangePickerAACompliant = (isRequired: boolean) => {
  document
    .querySelector(".e-daterangepicker")
    ?.setAttribute("aria-controls", "datepicker_popup");

  const calendarIcon = document.querySelectorAll(".e-input-group-icon");
  calendarIcon?.forEach(ci => ci.removeAttribute("aria-label"));

  const ariaLabelRemoval = document.querySelectorAll(
    "div.e-daterangepicker div, div.e-day-span"
  );
  ariaLabelRemoval?.forEach(div => div.removeAttribute("aria-label"));

  const tdSections = document.querySelectorAll("td.e-cell");
  tdSections?.forEach(div => div.removeAttribute("aria-selected"));

  document
    .querySelectorAll("input.e-daterange-hidden")
    ?.forEach(dateRangeHidden => {
      dateRangeHidden.setAttribute("aria-label", "date range picker");
      dateRangeHidden.setAttribute(
        "aria-required",
        `${isRequired ? "true" : "false"}`
      );
      dateRangeHidden.setAttribute("aria-invalid", "false");
    });
};

const makeDropDownTreeAACompliant = () => {
  document
    .querySelectorAll("span.e-input-group.e-control-wrapper")
    ?.forEach(dropDown => {
      dropDown.removeAttribute("role");
      dropDown.removeAttribute("aria-disabled");
      dropDown.removeAttribute("aria-haspopup");
      dropDown.removeAttribute("aria-expanded");
      dropDown.removeAttribute("aria-activedescendant");
      dropDown.removeAttribute("aria-labelledby");
      dropDown.removeAttribute("aria-owns");
      dropDown.removeAttribute("role");
    });
  document
    .querySelectorAll("input.e-control.e-dropdowntree")
    ?.forEach(selector => selector.setAttribute("aria-label", "selector"));
  document
    .querySelectorAll("ul.e-list-parent.e-ul")
    ?.forEach(selector => selector.setAttribute("aria-label", "Item selector"));
};

const makeDateTimePickerAACompliant = () => {
  document
    .querySelectorAll("span.e-input-group-icon.e-date-icon.e-icons")
    .forEach(item => item.removeAttribute("aria-label"));
};

export {
  makeGridAACompliant,
  makeDateRangePickerAACompliant,
  makeDropDownTreeAACompliant,
  makeDateTimePickerAACompliant
};
